Bands = new Mongo.Collection("bands");

Bands.allow({
  insert: function(userId, doc) {
    return !!userId;
  },
  update: function(userId, doc, modifier) {
    return !!userId;
  }
});

memberSchema = new SimpleSchema({
  name: {
    type: String,
    label: "Name"
  },
  instrument: {
    type: [String],
    label: "Instrument",
    autoform: {
      type: "select-checkbox-inline",
      options: function () {
        return [ 
          {label: 'Gitarre', value: 'Gitarre'},
          {label: 'Lead Gitarre', value: 'Lead-Gitarre'},
          {label: 'Rhytmus Gitarre', value: 'Rhytmus-Gitarre'},
          {label: 'Western Gitarre', value: 'Western-Gitarre'},
          {label: 'Gesang', value: 'Gesang'},
          {label: 'Backings', value: 'Backings'},
          {label: 'Bass', value: 'Bass'},
          {label: 'Turntables', value: 'Turntables'},
          {label: 'Beats', value: 'Beats'},
          {label: 'Schlagzeug', value: 'Schlagzeug'},
          {label: 'Percussion', value: 'Percussion'},
          {label: 'Keyboard', value: 'Keyboard'},
          {label: 'Synthesizer', value: 'Synthesizer'},
          {label: 'Harp', value: 'Harp'},
          {label: 'Blues Harp', value: 'Blues Harp'},
          {label: 'Saxofon', value: 'Saxofon'},
          {label: 'Posaune', value: 'Posaune'},
          {label: 'Trompete', value: 'Trompete'}
        ];
      }
    }
  }
})

bandSchema = new SimpleSchema({
  contactPerson: {
    type: String,
    label: "Wähle eine Kontaktperson",
    autoform: {
      options: function() {
        return _.map(Meteor.users.find({}).fetch(), function(c) {
          return {label: c.emails[0].address, value: c._id};

        });
      }
    }
  },
  picture: {
    type: String,
    optional: true,
    autoform: {
      afFieldInput: {
        type: 'fileUpload',
        collection: 'Images',
        label: 'Wähle dein Bild aus',
        accept: 'images/*'
        // selectFileBtnTemplate: 'bandUploadField'
      }
    },
  },
  name: {
    type: String,
    label: "Bandname"
  },
  bandId: {
    type: Number,
    label: "BandId",
    optional: true,
    autoform: {
      type: "hidden"
    }
  },
  contactEmail:{
    type: String,
    label: "E-Mail-Adresse",
    optional: true
  },
  contactName:{
    type: String,
    label: "Kontaktperson",
    optional: true
  },
  contactTelefon:{
    type: String,
    label: "Telefon",
    optional: true
  },
  roomNumber: {
    type: String,
    label: "Raum Nummer",
    optional: true
  },
  style: {
    type: String,
    label: "Style",
    optional: true,
  },
  promo: {
    type: String,
    label: "Promotext",
    max: 500,
    optional: true
  },
  homepage: {
    type: String, 
    label: "Homepage",
    optional: true
  },
  facebook: {
    type: String,
    label: "Facebook",
    optional: true
  },
  members: {
    type: [memberSchema],
    max: 10,
    label: "Bandmitglieder",
    optional: true
  },
  createdAt: {
    type: Date,
    label: "Created At",
    autoValue: function() {
      return new Date()
    },
    autoform: {
      type: "hidden"
    }
  },
  modifiedAt: {
    type: Date,
    label: "Updated At",
    optional: true,
    autoform: {
      type: "hidden"
    },
    autoValue: function() {
      if (this.isUpdate) {
        return new Date();
      }
    }
  }
});

Bands.attachSchema(bandSchema);


Bands.helpers({
  bandMembersCount: function() {
    band = Bands.findOne({_id: this._id});
    if ( typeof band.members != "undefined") {
      return band.members.length
    }else {
      return 0
    }
  }
});
